document.addEventListener("DOMContentLoaded", function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get("pq-main-cart")) {
    customElements.define(
      "pq-main-cart",
      class PqMainCart extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          if (window.customTracker) {
            window.customTracker.trackEvent({
              eventKey: 'Show_Cart_Render_Page',
              eventName: '购物车页面曝光事件',
            });
          }
          this.sectionId =
            this.querySelector(".main-cart-section").getAttribute(
              "data-section-id"
            );
          const buyNowBtn = document.querySelector(".buy-now-btn-cart-main-page");
          const rotateIcon = buyNowBtn.querySelector(".rotate_icon");
          if (rotateIcon) {
            rotateIcon.classList.remove("flex");
            rotateIcon.classList.add("hidden");
          }
          this.initSelectMenus();
          this.initInputNumber();
          this.initCartPopupMessage();
          this.initRemoveButtons();
          this.buyNowBtn();
          this.initConfirmDialog();
          this.initRemoveDiscountButtons();
          this.initDiscountCodeTags();
        }
        disconnectedCallback() {
          // 清理事件监听器
          if (this._documentClickHandler) {
            document.removeEventListener("click", this._documentClickHandler);
          }
        }
        async handleRemoveItem(cartItemId) {
          const sectionId =
            this.querySelector(".main-cart-section").dataset.sectionId;
          // 获取购物车项的 key
          const cartItem = this.querySelector(`.main-cart-item[data-id="${cartItemId}"]`);
          const cartItemKey = cartItem?.dataset.key;

          if (!cartItemKey) {
            console.warn("找不到购物车项key");
            return;
          }

          try {
            const response = await fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: cartItemKey,
                quantity: 0,
                sections: sectionId.trim() + ",cart-icon-bubble,mobile-cart-icon-bubble",
              }),
            });

            if (response.ok) {
              const cartData = await response.json();
              if (cartData.sections?.[sectionId.trim()]) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(
                  cartData.sections[sectionId.trim()],
                  "text/html"
                );
                const mainCartSection = doc.querySelector(".main-cart-section");

                if (mainCartSection) {
                  this.querySelector(".main-cart-section").innerHTML =
                    mainCartSection.innerHTML;

                  // 重新绑定所有事件
                  this.sectionId =
                    this.querySelector(".main-cart-section").getAttribute(
                      "data-section-id"
                    );
                  this.initSelectMenus();
                  this.initInputNumber();
                  this.initCartPopupMessage();
                  this.initRemoveButtons();
                }
              }

              // 更新购物车图标
              this.updateCartIconBubble(cartData);
            }
          } catch (error) {
            console.error("删除商品失败:", error);
          }
        }

        initInputNumber() {
          // 移除旧的事件监听器
          if (this._quantityChangeHandler) {
            this.removeEventListener("main-cart-quantity-change", this._quantityChangeHandler);
          }

          // 清除可能存在的按钮直接绑定
          const inputNumberComponents = this.querySelectorAll('input-number');
          inputNumberComponents.forEach((component) => {
            const minusButton = component.querySelector('.minus');
            const plusButton = component.querySelector('.plus');
            const input = component.querySelector('input');

            // 移除旧的事件监听器
            if (minusButton && minusButton._cartClickHandler) {
              minusButton.removeEventListener('click', minusButton._cartClickHandler);
              delete minusButton._cartClickHandler;
            }
            if (plusButton && plusButton._cartClickHandler) {
              plusButton.removeEventListener('click', plusButton._cartClickHandler);
              delete plusButton._cartClickHandler;
            }
            if (input && input._cartBlurHandler) {
              input.removeEventListener('blur', input._cartBlurHandler);
              delete input._cartBlurHandler;
            }
          });

          // 只添加一个事件监听器 - 通过main-cart-quantity-change事件
          this._quantityChangeHandler = (event) => {
            const { value, element } = event.detail;
            const cartOptionContainer = element.closest('.main-cart-option-container');
            const cartItemId = cartOptionContainer?.getAttribute('data-cart-id');
            const cartItemKey = cartOptionContainer?.getAttribute('data-cart-key');
            const input = element.querySelector('input');
            const inputNumberContainer = element.querySelector('.input-number-container');
            const defaultVal = input?.defaultValue;

            if (cartItemId && cartItemKey && input && inputNumberContainer) {
              this.triggerQuantityChange(value, cartItemKey, input, inputNumberContainer, defaultVal);
            }
          };

          this.addEventListener("main-cart-quantity-change", this._quantityChangeHandler);
        }
        async triggerQuantityChange(
          newValue,
          key,
          input,
          blurContainer,
          defaultVal
        ) {
          try {
            const sectionId =
              this.querySelector(".main-cart-section").dataset.sectionId;
            const response = await fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: key,
                quantity: newValue,
                sections: sectionId.trim() + ",cart-icon-bubble,mobile-cart-icon-bubble",
              }),
            });

            if (response.ok) {
              const cartData = await response.json();
              if (cartData.sections?.[sectionId.trim()]) {
                // 保存当前的滚动位置
                const scrollPosition = window.scrollY;

                const parser = new DOMParser();
                const doc = parser.parseFromString(
                  cartData.sections[sectionId.trim()],
                  "text/html"
                );
                const mainCartSection = doc.querySelector(".main-cart-section");

                if (mainCartSection) {
                  this.querySelector(".main-cart-section").innerHTML =
                    mainCartSection.innerHTML;
                  // 重新初始化所有事件监听器
                  this.reinitializeAfterUpdate();

                  // 恢复滚动位置
                  window.scrollTo(0, scrollPosition);
                  input.value = newValue;
                  const event = new CustomEvent("quantityChange", {
                    detail: input.value,
                  });
                  window.dispatchEvent(event); // 触发事件
                }
              }

              // 更新购物车图标
              this.updateCartIconBubble(cartData);
            } else {
              const cartData = await response.json();
              if (response.status == 200) {
                input.value = newValue;
              } else {
                input.value = defaultVal;
                window.pqToast.showToast("error", cartData.message);
              }
            }
          } catch (error) {
            console.error("更新数量失败:", error);
          }
        }
        // 初始化默认选中Select
        initSelectMenus() {
          // 先移除所有已存在的事件监听器
          document.removeEventListener("click", this._documentClickHandler);

          const selectHeaders = this.querySelectorAll(".select-header");
          selectHeaders.forEach((header) => {
            const oldElements = header._elements;
            if (oldElements) {
              header.removeEventListener("click", this._headerClickHandler);
              oldElements.optionsList?.removeEventListener(
                "click",
                this._optionsListClickHandler
              );
            }

            // 获取相关元素
            const valueSpan = header.querySelector(".select-value");
            const optionsContainer = header.nextElementSibling;
            const arrowIcon = header.querySelector(".arrow-icon");
            const optionsList = optionsContainer?.querySelector("ul");

            // 存储元素引用到 header 上，方便后续使用
            header._elements = {
              valueSpan,
              optionsContainer,
              arrowIcon,
              optionsList,
            };

            // 绑定事件
            if (header && optionsContainer) {
              // 点击 header 展开/收起
              header.addEventListener("click", (e) => {
                e.stopPropagation();
                const elements = header._elements;
                this.toggle(
                  header,
                  elements.optionsContainer,
                  elements.valueSpan,
                  elements.arrowIcon
                );
              });

              // 点击选项
              optionsList?.addEventListener("click", (e) => {
                const option = e.target.closest(".select-option");
                if (!option) return;

                e.stopPropagation();
                const inventoryQuantity = option.getAttribute(
                  "data-inventory_quantity"
                );

                // 如果有库存，才执行选择操作
                if (inventoryQuantity > 0) {
                  const elements = header._elements;
                  this.selectOption(option, header, elements);
                }
                // 如果库存为0，不执行任何操作，下拉菜单保持打开状态
              });
            }
          });

          // 重新绑定文档点击事件
          this._documentClickHandler = () => {
            selectHeaders.forEach((header) => {
              const elements = header._elements;
              if (elements) {
                this.close(
                  header,
                  elements.optionsContainer,
                  elements.valueSpan,
                  elements.arrowIcon
                );
              }
            });
          };
          document.addEventListener("click", this._documentClickHandler);
        }
        // 展开/收起下拉菜单
        toggle(header, optionsContainer, valueSpan, arrowIcon) {
          const isActive = header.classList.contains(
            "cart-active-select-menu-active"
          );

          if (!isActive) {
            // 展开前先关闭所有其他已打开的菜单
            const allActiveHeaders = this.querySelectorAll(
              ".select-header.cart-active-select-menu-active"
            );
            allActiveHeaders.forEach((activeHeader) => {
              if (activeHeader !== header && activeHeader._elements) {
                const elements = activeHeader._elements;
                this.close(
                  activeHeader,
                  elements.optionsContainer,
                  elements.valueSpan,
                  elements.arrowIcon
                );
              }
            });

            // 展开当前菜单
            header.classList.add("cart-active-select-menu-active");
            optionsContainer.style.maxHeight = "300px";
            optionsContainer.style.opacity = "1";
            optionsContainer.style.zIndex = "100";
            optionsContainer.querySelector('ul').style.height = "auto";
            valueSpan.style.color = "#acacac";
            arrowIcon.style.transform = "rotate(-180deg)";
          } else {
            // 收起
            this.close(header, optionsContainer, valueSpan, arrowIcon);
          }
        }
        // 关闭下拉菜单
        close(header, optionsContainer, valueSpan, arrowIcon) {
          header.classList.remove("cart-active-select-menu-active");
          optionsContainer.style.maxHeight = "0";
          optionsContainer.style.opacity = "0";
          optionsContainer.style.zIndex = "50";
          optionsContainer.querySelector('ul').style.height = "0";
          valueSpan.style.color = "";
          arrowIcon.style.transform = "";
        }
        // 选择选项
        selectOption(option, header, elements) {
          const { valueSpan, optionsContainer, arrowIcon, optionsList } =
            elements;
          const inventoryQuantity = option.getAttribute(
            "data-inventory_quantity"
          );

          // 如果库存为0，直接返回，不执行任何操作
          if (inventoryQuantity == 0) {
            return;
          }

          // 更新选中状态
          optionsList.querySelectorAll(".select-option").forEach((opt) => {
            opt.classList.remove("text-orange-500", "selected");
          });
          option.classList.add("text-orange-500", "selected");
          valueSpan.textContent = option.textContent;

          // 获取变体 ID
          const variantId = option.getAttribute("data-variant_id");
          if (variantId) {
            // 更新购物车项的变体
            this.updateCartItemVariant(
              variantId,
              header,
              option,
              inventoryQuantity
            );
          }

          // 关闭下拉
          this.close(header, optionsContainer, valueSpan, arrowIcon);
        }

        // 更新购物车项变体
        async updateCartItemVariant(
          variantId,
          header,
          option,
          inventoryQuantity
        ) {
          // 获取当前购物车项的 ID
          const cartItem = header.closest(".main-cart-item");
          const cartItemId = cartItem?.dataset.id;

          // 从 input-number 组件中获取数量值，而不是直接从 input 获取
          const inputNumberComponent = cartItem.querySelector('input-number');
          let quantity;

          if (inputNumberComponent) {
            // 尝试从 input-number 组件的 input 元素中获取当前值
            const input = inputNumberComponent.querySelector('input');
            quantity = input ? input.value : '1';
          } else {
            // 如果没有找到 input-number 组件，则使用原来的方式作为备选
            const input = cartItem.querySelector('input[type="number"]');
            quantity = input ? input.value : '1';
          }

          const sectionId =
            this.querySelector(".main-cart-section").dataset.sectionId;

          if (!cartItemId) return;

          if (Number(quantity) > Number(inventoryQuantity)) {
            quantity = inventoryQuantity;
            window.pqToast.showToast("error", window.i18n.max_quantity);
          }

          try {
            // 构造 items 数组，包含旧变体设置为0和新变体的添加

            var formData = new FormData();
            formData.append(`updates[${cartItemId}]`, 0);
            formData.append(`updates[${variantId}]`, parseInt(quantity));
            formData.append(`sections`, sectionId.trim() + ",cart-icon-bubble,mobile-cart-icon-bubble");

            const response = await fetch("/cart/update.js", {
              method: "POST",
              body: formData,
            });
            if (response.ok) {
              const updateData = await response.json();
              // 更新购物车界面
              if (updateData.sections?.[sectionId.trim()]) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(
                  updateData.sections[sectionId.trim()],
                  "text/html"
                );
                const mainCartSection = doc.querySelector(".main-cart-section");
                if (mainCartSection) {
                  this.querySelector(".main-cart-section").innerHTML =
                    mainCartSection.innerHTML;
                  this.reinitializeAfterUpdate();
                }
              }
            } else {
              window.pqToast.showToast("error", window.i18n.add_to_cart_failed);
              window.location.reload();
            }
          } catch (error) {
            console.error("更新变体失败:", error);
            window.pqToast.showToast("error", window.i18n.noStock);
            window.location.reload();
          }
        }

        // 添加一个重新初始化所有事件的方法
        reinitializeEvents() {
          // 重新初始化下拉菜单
          this.initSelectMenus();

          // 重新初始化数量输入框
          this.initInputNumber();


          // 重新初始化留言和优惠码功能
          this.initCartPopupMessage();

          // 重新初始化删除按钮事件
          this.initRemoveButtons();
        }

        // 初始化留言和优惠码功能
        initCartPopupMessage() {
          // 获取所有留言文本框
          const textareas = this.querySelectorAll(".special-instructions");

          Array.from(textareas).forEach((textarea) => {
            const maxLength = textarea.getAttribute("maxlength");



            // 移除旧的事件监听器
            if (textarea._inputHandler) {
              textarea.removeEventListener("input", textarea._inputHandler);
            }
            if (textarea._keydownHandler) {
              textarea.removeEventListener("keydown", textarea._keydownHandler);
            }
            if (textarea._blurHandler) {
              textarea.removeEventListener("blur", textarea._blurHandler);
            }

            textarea.addEventListener("input", textarea._inputHandler);

            // 添加回车事件
            textarea._keydownHandler = async (e) => {
              // 检查是否按下回车键且没有按住 Shift 键
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();

                const messageContent = textarea.value;
                try {
                  const response = await fetch(`/cart/update`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ note: messageContent }),
                  });

                  if (response.ok) {
                    // 让文本框失去焦点
                    textarea.blur();
                    // 同步更新所有 textarea 的内容
                    Array.from(textareas).forEach((otherTextarea) => {
                      if (otherTextarea !== textarea) {
                        otherTextarea.value = messageContent;
                      }
                    });
                    const cartPopupMessage =
                      document.querySelector("cart-popup-message");
                    if (cartPopupMessage) {
                      cartPopupMessage.setAttribute(
                        "data-note",
                        messageContent
                      );
                      cartPopupMessage.value = messageContent;
                    }
                  }
                  if (!response.ok) {
                    window.pqToast.showToast("error", window.i18n.noStock);
                    return;
                  }
                } catch (error) {
                  console.error("更新留言失败:", error);
                }
              }
            };
            textarea.addEventListener("keydown", textarea._keydownHandler);

            // 添加移动端确认事件
            textarea._blurHandler = async () => {
              const messageContent = textarea.value;
              try {
                const response = await fetch(`/cart/update`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ note: messageContent }),
                });

                if (response.ok) {
                  // 同步更新所有 textarea 的内容
                  Array.from(textareas).forEach((otherTextarea) => {
                    if (otherTextarea !== textarea) {
                      otherTextarea.value = messageContent;
                    }
                  });
                  // 更新所有字符计数
                  const cartPopupMessage =
                    document.querySelector("cart-popup-message");
                  if (cartPopupMessage) {
                    cartPopupMessage.setAttribute("data-note", messageContent);
                    cartPopupMessage.value = messageContent;
                  }
                }
                if (!response.ok) {
                  window.pqToast.showToast("error", window.i18n.noStock);
                  return;
                }
              } catch (error) {
                console.error("更新留言失败:", error);
              }
            };
            textarea.addEventListener("blur", textarea._blurHandler);
          });

          // 添加优惠码输入处理（主购物车 Apply 逻辑）
          const discountCodeInput = this.querySelector("#discount-code");
          const discountApplyButton = this.querySelector("#discount-code-apply");
          const couponErrorMessage = this.querySelector(".cart-coupon-error-message");
          if (discountCodeInput && discountApplyButton) {
            // 先移除旧的事件监听器
            if (discountCodeInput._inputHandler) {
              discountCodeInput.removeEventListener("input", discountCodeInput._inputHandler);
            }
            if (discountApplyButton._clickHandler) {
              discountApplyButton.removeEventListener("click", discountApplyButton._clickHandler);
            }

            // 输入时控制按钮 disabled 状态，并清除错误提示
            discountCodeInput._inputHandler = () => {
              const value = discountCodeInput.value.trim();

              // 每次输入都清除错误样式和错误文案
              discountCodeInput.classList.remove("error");
              if (couponErrorMessage) {
                couponErrorMessage.classList.add("hidden");
              }

              if (value) {
                discountApplyButton.removeAttribute("disabled");
              } else {
                discountApplyButton.setAttribute("disabled", "disabled");
              }
            };
            discountCodeInput.addEventListener("input", discountCodeInput._inputHandler);

            // 初始状态：如果为空则禁用按钮
            if (!discountCodeInput.value.trim()) {
              discountApplyButton.setAttribute("disabled", "disabled");
            }

            // 点击 Apply 按钮时应用优惠码
            discountApplyButton._clickHandler = async () => {
              await this.applyMainCartCoupon();
            };
            discountApplyButton.addEventListener("click", discountApplyButton._clickHandler);

            // 回车键快捷触发
            discountCodeInput.addEventListener("keydown", (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                if (!discountApplyButton.hasAttribute("disabled")) {
                  this.applyMainCartCoupon();
                }
              }
            });
          }
        }
        showMessage(message) {
          const toast = document.createElement("div");
          toast.innerText = message;
          toast.style.visibility = "hidden";
          toast.style.minWidth = "7.5rem";
          toast.style.backgroundColor = "#666666";
          toast.style.color = "#fff";
          toast.style.textAlign = "center";
          toast.style.borderRadius = "0.5rem";
          toast.style.padding = "0.63rem 1.5rem";
          toast.style.position = "fixed";
          toast.style.zIndex = "600";
          toast.style.left = "50%";
          toast.style.top = "50%";
          toast.style.fontSize = "1rem";
          toast.style.transform = "translate(-50%, -50%)";

          // 添加到文档中
          document.body.appendChild(toast);

          // 显示吐司
          toast.style.visibility = "visible";

          // 2秒后隐藏并移除吐司
          setTimeout(() => {
            toast.style.visibility = "hidden";
            document.body.removeChild(toast);
          }, 2000);
        }
        buyNowBtn() {
          // 使用querySelectorAll获取所有结账按钮
          const buyNowBtns = document.querySelectorAll(".buy-now-btn-cart-main-page");

          if (buyNowBtns.length === 0) {
            return;
          }


          // 为每个按钮绑定事件
          buyNowBtns.forEach((btn, index) => {
            // 先移除所有已有的点击事件(通过克隆替换节点)
            const newBtn = btn.cloneNode(true);
            btn.parentNode.replaceChild(newBtn, btn);

            // 添加新的点击事件
            newBtn.addEventListener("click", function (e) {
              e.preventDefault(); // 阻止默认行为

              // 添加loading状态
              this.classList.add('loading');

              // 延迟执行跳转，确保用户看到按钮状态变化
              setTimeout(() => {
                window.location.href = `/checkout`;
              }, 100);
            });
          });
        }
        // 主购物车应用优惠码（参考抽屉 saveCoupon 逻辑）
        async applyMainCartCoupon() {
          const input = this.querySelector("#discount-code");
          const applyButton = this.querySelector("#discount-code-apply");
          const errorMessage = this.querySelector(".cart-coupon-error-message");
          const couponCode = input?.value?.trim() || "";

          if (!couponCode) {
            // 空输入不提示，仅返回
            return;
          }
          if (window.customTracker) {
            window.customTracker.trackEvent({
              eventKey: 'Click_Cart_ApplyDiscount_Btn',
              eventName: '购物车页面应用折扣码按钮点击事件',
              eventValue: {
                discountCode: couponCode
              }
            });
          }
          const sectionId = this.querySelector(".main-cart-section")?.dataset.sectionId;

          try {
            if (applyButton) {
              applyButton.classList.add("loading");
            }
            // 清除之前的错误状态
            if (input) {
              input.classList.remove("error");
            }
            if (errorMessage) {
              errorMessage.classList.add("hidden");
            }

            // 获取现有优惠码列表
            const discountApplicationsInput = this.querySelector('input[name="discount_applications"]');
            const existingDiscounts = discountApplicationsInput?.value || "";
            let discountsArray = existingDiscounts
              ? existingDiscounts.split(",").map((d) => d.trim()).filter((d) => d)
              : [];

            if (!discountsArray.includes(couponCode)) {
              discountsArray.push(couponCode);
            }

            const discountsString = discountsArray.join(",");

            const response = await fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                discount: discountsString,
                sections: `${sectionId?.trim() || ""},cart-icon-bubble,mobile-cart-icon-bubble`,
              }),
            });

            if (!response.ok) {
              throw new Error("应用优惠券失败");
            }
       
            const cartData = await response.json();

            // 检查优惠码是否有效
            let isInvalid = false;
            if (cartData.discount_codes) {
              const currentDiscount = cartData.discount_codes.find(
                (d) => d.code && d.code.toLowerCase() === couponCode.toLowerCase()
              );
              if (currentDiscount && currentDiscount.applicable === false) {
                isInvalid = true;
              }
            }

            // 追踪应用折扣码结果（成功或失败）
            if (window.customTracker) {
              window.customTracker.trackEvent({
                eventKey: 'Callback_Cart_ApplyDiscount_Result',
                eventName: '购物车页面应用折扣码结果事件',
                eventStatus: isInvalid ? 'fail' : 'success',
                eventValue: {
                  discountCode: couponCode
                }
              });
            }

            if (isInvalid) {
              // 显示红框和错误文案，不使用 pqToast
              if (input) {
                input.classList.add("error");
              }
              if (errorMessage) {
                errorMessage.classList.remove("hidden");
              }
              return;
            }
            // 更新主购物车 section
            if (cartData.sections && sectionId && cartData.sections[sectionId.trim()]) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(cartData.sections[sectionId.trim()], "text/html");
              const mainCartSection = doc.querySelector(".main-cart-section");
              if (mainCartSection) {
                this.querySelector(".main-cart-section").innerHTML = mainCartSection.innerHTML;
                this.reinitializeAfterUpdate();
              }
            }

            // 更新购物车图标
            this.updateCartIconBubble(cartData);
          } catch (error) {
            console.error("应用优惠券失败:", error);
          } finally {
            if (applyButton) {
              applyButton.classList.remove("loading");
              applyButton.removeAttribute("disabled");
            }
          }
        }
        // 关闭确认对话框
        closeConfirmDialog() {
          const dialog = document.querySelector('#pq-cart-confirm-dialog');
          if (dialog) {
            dialog.classList.remove('show');
            window.pq.scrollEnable();
            this.confirmCallback = null;

            // 移除按钮的 loading 状态
            const confirmBtn = document.querySelector('#pq-cart-confirm-confirm');
            if (confirmBtn) {
              confirmBtn.classList.remove('loading');
            }
          }
        }

        // 初始化确认对话框（只绑定关闭相关按钮，确认按钮在 showConfirmDialog 中绑定，避免与 pq-cart-drawer 冲突）
        initConfirmDialog() {
          const dialog = document.querySelector('#pq-cart-confirm-dialog');
          if (!dialog) {
            console.warn('确认对话框未找到');
            return;
          }

          // 绑定关闭按钮
          const closeBtn = document.querySelector('#pq-cart-confirm-close');
          if (closeBtn) {
            closeBtn.onclick = () => {
              this.closeConfirmDialog();
            };
          }

          // 绑定取消按钮
          const cancelBtn = document.querySelector('#pq-cart-confirm-cancel');
          if (cancelBtn) {
            cancelBtn.onclick = () => {
              this.closeConfirmDialog();
            };
          }

          // 绑定遮罩层
          const overlay = dialog.querySelector('.pq-cart-confirm-overlay');
          if (overlay) {
            overlay.onclick = () => {
              this.closeConfirmDialog();
            };
          }
        }

        // 显示确认对话框
        showConfirmDialog(options) {
          const dialog = document.querySelector('#pq-cart-confirm-dialog');
          const title = document.querySelector('#pq-cart-confirm-title');
          const productContainer = document.querySelector('#pq-cart-confirm-product');
          const productImg = document.querySelector('#pq-cart-confirm-product-img');
          const productTitle = document.querySelector('#pq-cart-confirm-product-title');
          const productQuantity = document.querySelector('#pq-cart-confirm-product-quantity');

          if (!dialog) return;

          // 设置标题
          if (title) {
            title.textContent = options.title;
          }

          // 设置产品信息（如果是删除产品）
          if (options.type === 'product' && options.productInfo) {
            productContainer.style.display = 'flex';
            if (productImg) productImg.src = options.productInfo.image;
            if (productTitle) productTitle.textContent = options.productInfo.title;

            // 显示变体标题，如果是 Default Title 则隐藏整个元素
            if (productQuantity) {
              if (options.productInfo.variant && options.productInfo.variant !== 'Default Title') {
                productQuantity.textContent = options.productInfo.variant;
                productQuantity.style.display = 'block';
              } else {
                productQuantity.style.display = 'none';
              }
            }
          } else {
            // 如果是type是disount则给 title 添加一个 class 为 discount-title
            if (options.type === 'discount') {
              dialog.classList.add('pq-cart-confirm-discount');
            }
            productContainer.style.display = 'none';
          }

          // 保存确认回调
          this.confirmCallback = options.onConfirm;
          console.log(" this.confirmCallback", this.confirmCallback)
          // 显示对话框
          dialog.classList.add('show');
          if (window.pq && typeof window.pq.scrollDisable === 'function') {
            window.pq.scrollDisable();
          }

          // 每次显示对话框时，重新绑定确认按钮点击事件，确保使用 main-cart 的回调
          const confirmBtn = document.querySelector('#pq-cart-confirm-confirm');
          if (confirmBtn) {
            confirmBtn.onclick = async () => {
              // 添加 loading 状态
              confirmBtn.classList.add("loading");

              if (this.confirmCallback) {
                await this.confirmCallback();
              }
            };
          }
        }

        // 添加初始化删除按钮的方法
        initRemoveButtons() {
          const removeButtons = this.querySelectorAll(".icon-close");
          removeButtons.forEach((button) => {
            // 移除旧的事件监听器（使用克隆替换）
            const newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);

            newButton.addEventListener("click", (event) => {
              event.preventDefault();
              const cartItem = newButton.closest(".main-cart-item");

              if (!cartItem) return;

              // 从 data 属性中获取产品信息
              const itemId = cartItem.dataset.id;
              const itemKey = cartItem.dataset.key;
              const productTitle = cartItem.dataset.productTitle || '';
              const productImage = cartItem.dataset.productImage || '';
              const productVariantTitle = cartItem.dataset.productVariantTitle || '';

              // 显示确认对话框
              this.showConfirmDialog({
                type: 'product',
                title: window.i18n.confirm_removal,
                productInfo: {
                  image: productImage,
                  title: productTitle,
                  variant: productVariantTitle
                },
                onConfirm: () => {
                  this.confirmRemoveItem(itemId, itemKey);
                }
              });
            });
          });
        }

        // 确认删除商品
        async confirmRemoveItem(itemId, itemKey) {
          const sectionId =
            this.querySelector(".main-cart-section").dataset.sectionId;

          // 找到对应的购物车项
          const cartItem = this.querySelector(`.main-cart-item[data-id="${itemId}"]`);

          if (cartItem) {
            // 获取加载容器并显示加载状态
            const loaderContainer = cartItem.querySelector(
              ".main-cart-item-left-image-loader-container"
            );
            if (loaderContainer) {
              loaderContainer.classList.add("show");
            }
          }

          if (!itemKey) {
            console.warn("找不到购物车项key");
            return;
          }

          try {
            const response = await fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: itemKey,
                quantity: 0,
                sections: sectionId.trim() + ",cart-icon-bubble,mobile-cart-icon-bubble",
              }),
            });

            if (response.ok) {
              const cartData = await response.json();
              if (cartData.sections?.[sectionId.trim()]) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(
                  cartData.sections[sectionId.trim()],
                  "text/html"
                );
                const mainCartSection =
                  doc.querySelector(".main-cart-section");

                if (mainCartSection) {
                  this.querySelector(".main-cart-section").innerHTML =
                    mainCartSection.innerHTML;
                  this.reinitializeAfterUpdate();
                  this.updateCartIconBubble(cartData);
                }
              }
            }
          } catch (error) {
            console.error("删除商品失败:", error);
          } finally {
            // 移除加载状态
            if (cartItem) {
              const loaderContainer = cartItem.querySelector(
                ".main-cart-item-left-image-loader-container"
              );
              if (loaderContainer) {
                loaderContainer.classList.remove("show");
              }
            }
            // 关闭对话框
            this.closeConfirmDialog();
          }
        }

        // 初始化删除优惠券按钮
        initRemoveDiscountButtons() {
          const removeButtons = this.querySelectorAll('.discount-code-tag-remove');

          removeButtons.forEach(button => {
            // 移除旧的事件监听器（使用克隆替换）
            const newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);

            // 添加点击事件
            newButton.addEventListener('click', (e) => {
              e.stopPropagation(); // 防止触发其他点击事件
              this.removeDiscount(newButton.getAttribute('data-discount-code'));
            });
          });
        }

        // 删除优惠券
        removeDiscount(discountCodeToRemove) {
          if (!discountCodeToRemove) return;

          // 显示确认对话框
          this.showConfirmDialog({
            type: 'discount',
            title: window.i18n.remove_promo_code + ' (' + discountCodeToRemove + ')',
            onConfirm: () => {
              this.confirmRemoveDiscount(discountCodeToRemove);
            }
          });
        }

        // 确认删除优惠券
        async confirmRemoveDiscount(discountCodeToRemove) {
          const sectionId =
            this.querySelector(".main-cart-section").dataset.sectionId;

          try {
            // 收集所有剩余的优惠券（除了要删除的那个）
            const allDiscountTags = this.querySelectorAll('.discount-code-tag');
            const remainingDiscounts = [];

            allDiscountTags.forEach(tag => {
              const code = tag.getAttribute('data-discount-code');
              if (code && code !== discountCodeToRemove) {
                remainingDiscounts.push(code);
              }
            });
            if (window.customTracker) {
              // 购物车页面删除折扣码按钮点击事件
              window.customTracker.trackEvent({
                eventKey: 'Click_Cart_DeleteDiscount_Btn',
                eventName: '购物车页面删除折扣码按钮点击事件',
                eventValue: {
                  discountCode: discountCodeToRemove
                }
              });
            }
            // 将数组转换为逗号分隔的字符串
            const discountsString = remainingDiscounts.join(',');

            // 调用 Shopify API 更新购物车
            const response = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                discount: discountsString,
                sections: sectionId.trim() + ",cart-icon-bubble,mobile-cart-icon-bubble",
              })
            });

            if (!response.ok) {
              throw new Error('删除优惠券失败');
            }
            if (window.customTracker) {
              // 购物车页面删除折扣码结果事件
              window.customTracker.trackEvent({
                eventKey: 'Callback_Cart_DeleteDiscount_Result',
                eventName: '购物车页面删除折扣码结果事件',
                eventStatus: response.ok ? 'success' : 'fail',
                eventValue: {
                  discountCode: discountCodeToRemove
                }
              });
            }
            const cartData = await response.json();

            // 更新购物车部分
            if (cartData.sections?.[sectionId.trim()]) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(
                cartData.sections[sectionId.trim()],
                "text/html"
              );
              const mainCartSection =
                doc.querySelector(".main-cart-section");

              if (mainCartSection) {
                this.querySelector(".main-cart-section").innerHTML =
                  mainCartSection.innerHTML;
                this.reinitializeAfterUpdate();
                this.updateCartIconBubble(cartData);
              }
            }
          } catch (error) {
            console.error("删除优惠券失败:", error);
          } finally {
            // 关闭对话框
            this.closeConfirmDialog();
          }
        }

        // 与抽屉一致的 tooltip 定位逻辑
        updateTooltipPosition(tag, tooltipElement) {
          if (!tag || !tooltipElement) return;

          const tagRect = tag.getBoundingClientRect();

          // 以当前折扣码所在的 codes 容器为定位参考
          const codesContainer = tag.closest('.cart-drawer-footer-discount-codes');
          if (!codesContainer) return;

          const containerRect = codesContainer.getBoundingClientRect();

          // 气泡不超出主购物车容器：以 cart-right-container-item 为边界，考虑左右各 24px 的 padding（1200px 及以下为 20px）
          const cartRightContainerItem = this.closest('.main-cart-container')?.querySelector('.cart-right-container-item');
          const containerRectForBoundary = cartRightContainerItem ? cartRightContainerItem.getBoundingClientRect() : (this.closest('.main-cart-container') || this).getBoundingClientRect();
          // 1200px 及以下为 20px，大于 1200px 为 24px
          const containerPadding = window.innerWidth <= 1200 ? 20 : 24;

          // 先临时显示 tooltip 以获取尺寸
          const originalOpacity = tooltipElement.style.opacity;
          const originalVisibility = tooltipElement.style.visibility;
          const originalDisplay = tooltipElement.style.display;
          const originalMaxWidth = tooltipElement.style.maxWidth;

          // 动态设置最大宽度：不超过 cart-right-container-item 区域（考虑左右各 24px 的 padding）
          const maxTooltipWidth = containerRectForBoundary.width - containerPadding * 2;
          tooltipElement.style.maxWidth = `${maxTooltipWidth}px`;

          tooltipElement.style.opacity = '1';
          tooltipElement.style.visibility = 'hidden';
          tooltipElement.style.display = 'block';

          // 强制浏览器重新计算布局（考虑新的 max-width）
          tooltipElement.offsetHeight;

          const tooltipRect = tooltipElement.getBoundingClientRect();

          // 恢复原始样式（但保留 max-width，确保不超出容器）
          tooltipElement.style.opacity = originalOpacity || '';
          tooltipElement.style.visibility = originalVisibility || '';
          tooltipElement.style.display = originalDisplay || '';
          // max-width 保留设置，不恢复

          // ------- 水平：以 tag 为中心，但气泡不超出主购物车容器 -------
          const tagCenterXRelative =
            tagRect.left - containerRect.left + tagRect.width / 2;
          const tooltipHalfWidth = tooltipRect.width / 2;

          // 理想中心 = tag 中心
          let tooltipCenterX = tagCenterXRelative;

          // 气泡左右边在视口中的位置（相对 container 的 left 来算）
          const tooltipLeftV = containerRect.left + tooltipCenterX - tooltipHalfWidth;
          const tooltipRightV = containerRect.left + tooltipCenterX + tooltipHalfWidth;

          // 考虑 cart-right-container-item 左右各 24px 的 padding，确保不超出
          if (tooltipLeftV < containerRectForBoundary.left + containerPadding) {
            tooltipCenterX = containerRectForBoundary.left + containerPadding - containerRect.left + tooltipHalfWidth;
          } else if (tooltipRightV > containerRectForBoundary.right - containerPadding) {
            tooltipCenterX = containerRectForBoundary.right - containerPadding - containerRect.left - tooltipHalfWidth;
          }

          tooltipElement.style.left = `${tooltipCenterX}px`;
          tooltipElement.style.transform = 'translateX(-50%)';

          // 箭头始终跟随当前 discount-code-tag 正中心（悬浮时箭头浮在 tag 上）
          const arrowOffset = tagCenterXRelative - tooltipCenterX;
          tooltipElement.style.setProperty('--arrow-offset', `${arrowOffset}px`);

          // ------- 垂直：相对于 codes 容器，默认上方 10px，不够则下方 10px -------
          const tooltipHeight = tooltipRect.height;
          let tooltipTop = -tooltipHeight - 10;
          const spaceAbove = containerRect.top;
          if (spaceAbove < tooltipHeight + 10) {
            tooltipTop = codesContainer.offsetHeight + 10;
          }

          tooltipElement.style.top = `${tooltipTop}px`;
        }

        // 初始化折扣标签点击和 tooltip
        initDiscountCodeTags() {
          const discountTags = this.querySelectorAll('.discount-code-tag');

          discountTags.forEach(tag => {
            const titleElement = tag.querySelector('.discount-code-title');
            const removeButton = tag.querySelector('.discount-code-tag-remove');
            const fullTitle = tag.getAttribute('data-full-title') || '';
            const discountCode = tag.getAttribute('data-discount-code') || '';

            if (!titleElement) return;

            // 查找对应的 tooltip（在 discount-code-tag 外面）
            const codesContainer = tag.closest('.cart-drawer-footer-discount-codes');
            const tooltipElement = codesContainer?.querySelector(`.discount-code-tooltip[data-discount-tag-id="${discountCode}"]`);

            if (!tooltipElement) return;

            // 检测是否显示省略号
            const isEllipsis = titleElement.scrollWidth > titleElement.offsetWidth;

            if (isEllipsis && fullTitle) {
              // 添加 class 标识，用于应用 hover/active 背景色
              tag.classList.add('has-ellipsis');
              tooltipElement.textContent = fullTitle;

              // 检测是否为移动端
              const isMobile = window.matchMedia('(hover: none)').matches;

              if (isMobile) {
                // 移动端：点击显示/隐藏 tooltip（排除删除按钮）
                tag.addEventListener('click', (e) => {
                  // 如果点击的是删除按钮，不处理
                  if (removeButton && (removeButton.contains(e.target) || e.target.closest('.discount-code-tag-remove'))) {
                    return;
                  }
                  e.stopPropagation();
                  // 切换 tooltip 显示
                  const isShowing = tooltipElement.classList.contains('show-tooltip');
                  tag.classList.toggle('show-tooltip');
                  tooltipElement.classList.toggle('show-tooltip');
                  if (!isShowing) {
                    // 显示时更新位置
                    setTimeout(() => {
                      this.updateTooltipPosition(tag, tooltipElement);
                    }, 0);
                  }
                });

                // 移动端：点击外部关闭 tooltip
                const closeTooltip = (e) => {
                  if (!tag.contains(e.target) && !tooltipElement.contains(e.target)) {
                    tooltipElement.classList.remove('show-tooltip');
                    tag.classList.remove('show-tooltip');
                  }
                };
                document.addEventListener('click', closeTooltip);
              } else {
                // PC 端：悬浮显示 tooltip
                tag.addEventListener('mouseenter', () => {
                  tag.classList.add('show-tooltip');
                  tooltipElement.classList.add('show-tooltip');
                  // 更新 tooltip 位置
                  this.updateTooltipPosition(tag, tooltipElement);
                });

                tag.addEventListener('mouseleave', () => {
                  tag.classList.remove('show-tooltip');
                  tooltipElement.classList.remove('show-tooltip');
                });

                // 鼠标进入 tooltip 时保持显示
                tooltipElement.addEventListener('mouseenter', () => {
                  tag.classList.add('show-tooltip');
                  tooltipElement.classList.add('show-tooltip');
                });

                tooltipElement.addEventListener('mouseleave', () => {
                  tag.classList.remove('show-tooltip');
                  tooltipElement.classList.remove('show-tooltip');
                });
              }

              // 窗口大小改变时更新位置
              window.addEventListener('resize', () => {
                if (tooltipElement.classList.contains('show-tooltip')) {
                  this.updateTooltipPosition(tag, tooltipElement);
                }
              });
            }
          });
        }

        reinitializeAfterUpdate() {
          // 重新绑定所有事件
          this.sectionId =
            this.querySelector(".main-cart-section").getAttribute(
              "data-section-id"
            );
          this.initSelectMenus();
          this.initInputNumber();
          this.initCartPopupMessage();
          this.initRemoveButtons();
          this.initRemoveDiscountButtons();
          this.initDiscountCodeTags();
          this.buyNowBtn();
        }

        updateCartIconBubble(cartData) {
          // 更新购物车图标数量
          if (cartData.sections && cartData.sections["cart-icon-bubble"]) {
            const currentCartIcon = document.querySelector("#cart-icon-bubble");
            if (currentCartIcon) {
              currentCartIcon.innerHTML = cartData.sections["cart-icon-bubble"];
            }
          }

          // 更新移动端购物车图标
          if (cartData.sections && cartData.sections["mobile-cart-icon-bubble"]) {
            const currentMobileCartIcon = document.querySelector("#mobile-cart-icon-bubble");
            if (currentMobileCartIcon) {
              currentMobileCartIcon.innerHTML = cartData.sections["mobile-cart-icon-bubble"];
            }
          }

          // 如果直接返回了item_count也更新
          if (cartData.item_count !== undefined) {
            const cartIconBubble = document.querySelector("#cart-icon-bubble .absolute");
            if (cartIconBubble) {
              if (cartData.item_count === 0) {
                cartIconBubble.classList.add("hidden");
                cartIconBubble.innerHTML = "";
              } else {
                cartIconBubble.classList.remove("hidden");
                cartIconBubble.innerHTML =
                  cartData.item_count >= 99
                    ? '<div class="leading-[8px]">99+</div>'
                    : `<div class="leading-[8px]">${cartData.item_count}</div>`;
              }
            }
          }
        }
      }
    );
  }
});